import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./en";
import { cs } from "./cs";

const STORAGE_KEY = "admin-lang";

const stored = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

// Imported once for its init side-effect (see main.tsx) before any
// useTranslation() call. Init is synchronous (inline resources), so modules that
// `import i18n from "@/i18n"` may safely call i18n.t() at module scope.
i18n.use(initReactI18next).init({
  resources: { en, cs },
  lng: stored === "en" || stored === "cs" ? stored : "cs",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

/**
 * Switch the admin language. Persists the choice and reloads the page so that
 * module-scope labels (statusConfig, nav data, enum mirrors) re-evaluate — the
 * dictionaries are consumed both reactively and at import time.
 */
export function setAdminLanguage(lang: "cs" | "en") {
  localStorage.setItem(STORAGE_KEY, lang);
  window.location.reload();
}

/** BCP-47 locale matching the active admin language — for Intl/date formatting. */
export function uiLocale(): "cs-CZ" | "en-US" {
  return i18n.language === "cs" ? "cs-CZ" : "en-US";
}

export default i18n;
